import { publish } from '@jutro/events';
import _ from 'lodash';
import { ADOBE_TOPICS } from 'sg-adobe-analytics';
import { SgNumberUtil } from 'saga-modules';

/**
 * Emits an AddOn selection change event.
 * @param {Object} coverage
 * @param {String} productActionReason SG_AA_PROD_ACTION_REASON
 * @param {String} productActionLocation SG_AA_PROD_ACTION_LOC
 */
function emitAddOnChangeEvent(coverage, productActionReason, productActionLocation) {
    setTimeout(() => { // Let model stabilise
        const payload = { model: {}, addOnsArray: [] }; // Event payload definition
        const addOn = { // AddOn definition
            productActionReason: productActionReason,
            productActionLocation: productActionLocation
        };
        const hasLocationWhereChanged = !_.isNil(productActionLocation) && productActionLocation !== '';
        if (coverage.amount.amount) {
            addOn.price = SgNumberUtil.getFullPriceWithFraction(coverage.amount.amount);
        }
        if (coverage.valueMap) {
            addOn.value = coverage.valueMap;
        }
        if (coverage.selected === true) { // If AddOn was selected
            // Add to addOnsArray
            payload.addOnsArray.push(_.extend({ addOnProduct: coverage.name }, addOn));
            // Add to addedProductsArray
            if (hasLocationWhereChanged) {
                payload.model.addedProductsArray = [_.extend({ productAdded: coverage.name }, addOn)];
            }
        } else if (coverage.selected === false && hasLocationWhereChanged) { // If AddOn was removed
            // Add to removedProductsArray
            payload.model.removedProductsArray = [_.extend({ productRemoved: coverage.name }, addOn)];
        }
        return publish(ADOBE_TOPICS.ADDON_CHANGE, payload);
    });
}

function emitAddOnDeleteEvent(coverages, showRemovedProductArray) {
    setTimeout(() => { // Let model stabilise
        const payload = {
            model: {}, addOnsArray: [], addonsToDelete: []
        }; // Event payload definition

        if (showRemovedProductArray) {
            payload.model.removedProductsArray = [];
            coverages.forEach((coverage) => {
                payload.model.removedProductsArray.push({ productRemoved: coverage });
            });
        } else {
            coverages.forEach((coverage) => {
                payload.addonsToDelete.push({ productRemoved: coverage });
            });
        }
        return publish(ADOBE_TOPICS.ADDON_CHANGE, payload);
    });
}

export default {
    emitAddOnChangeEvent,
    emitAddOnDeleteEvent
};
